<template>
  <el-dialog :visible.sync="dialogVisible" width="90%" custom-class="custom-dialog" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
    <div slot="title" class="title">
      <div class="title-name">{{ dialogTitle }}</div>
      <div class="side-title"></div>
      <div class="dialog-close-btn" @click="cancelEdit">X</div>
    </div>
    <div class="edit-dialog-part">
      <div class="title" style="border:none;margin-bottom:0;">公司整体薪酬表</div>
      <div v-if="companyInEdit.companyMoneyTable" class="money-table-box" style="width:100%;margin-bottom:10px">
        <EditNewMoneyTable v-if="companyInEdit.companyMoneyTable.content" :table="companyInEdit.companyMoneyTable"></EditNewMoneyTable>
      </div>
      <div class="title" style="border:none;margin-bottom:0;">职能模块薪酬表</div>
      <div class="money-table-box" style="width:100%">
        <el-tabs v-model="activeCateTableInEditCate" type="card" @tab-click="editChooseCate">
          <el-tab-pane v-for="(value, key) in companyInEdit.categoryMoneyTable" :key="key" :label="key" :name="key">
          </el-tab-pane>
          <el-tab-pane label="+增加职能模块" name="+增加职能模块"> </el-tab-pane>
        </el-tabs>
        <EditNewMoneyTable v-if="activeCateTableInEdit.content" :table="activeCateTableInEdit"></EditNewMoneyTable>
      </div>
    </div>
    <div slot="footer">
      <el-row type="flex" align="center" justify="center">
        <el-button size="small" type="info" style="margin-right:20px;background-color: #ccced3;border-color: #ccced3;" @click="cancelEdit">取消</el-button>
        <el-button size="small" type="primary" class="custom-primary-plain" @click="confirmEdit(true)">保存</el-button>
      </el-row>
    </div>
    <!-- 选择职能模块弹窗 -->
    <SelectDialog ref="SelectDialog" :could-add="false" @choose="addCategory"></SelectDialog>
  </el-dialog>
</template>
<script>
import EditNewMoneyTable from '../../../../../company/src/component/EditNewMoneyTable'
import SelectDialog from '../../../../../company/src/knowledge/selectCategoryDialog'
import { moneyTable, moneyContent } from '../../../../../company/statistics/variant/table'

export default {
  components: { EditNewMoneyTable, SelectDialog },
  props: {
    company: { type: Object, default: () => ({}) },
    moneyTables: { type: Array, default: () => ([]) }
  },
  data() {
    return {
      dialogTitle:'修改薪酬',
      dialogVisible: false,
      activeMoneyTable:null,
      companyInEdit: {},
      activeCateTableInEdit: {},
      activeCateTableInEditCate: '',
    }
  },
  methods: {
    async open(company) {
      this.company = company
      const companyInEdit = {}
      // const fields = ['薪酬/职级/奖金机制','companyMoneyTable','categoryMoneyTable']
      const newTable = { table: moneyTable, content: moneyContent }
      companyInEdit.companyMoneyTable = window._.cloneDeep(company.companyMoneyTable || newTable)
      companyInEdit.categoryMoneyTable = window._.cloneDeep(company.categoryMoneyTable || {})
      const cates = Object.keys(companyInEdit.categoryMoneyTable)
      if (cates.length > 0) {
        this.activeCateTableInEdit = companyInEdit.categoryMoneyTable[cates[0]]
        this.activeCateTableInEditCate = cates[0]
      }
      this.companyInEdit = companyInEdit
      this.log = ''
      this.dialogVisible = true
    },
    async confirmEdit(notification) {
      if (!this.dialogVisible) return
      const res = await app.service('company').modifyCompany({
        query: { _id: this.company._id },
        data: this.companyInEdit,
      })
      if (res.status === 'success' || res.status === 200) {
        for(let key in this.companyInEdit){
          this.$set(this.company,key,this.companyInEdit[key])
        }
        // this.$emit('confirmEdit', { type: this.componentType, data: this.companyInEdit })
      } else this.$message.error(`修改失败:${res.msg}`)
      this.dialogVisible = false
    },
    cancelEdit() {
      this.dialogVisible = false
    },
    chooseCate(tab, event) {
      this.activeCateTable = this.company.categoryMoneyTable[tab.name]
      this.activeCateTablCate = tab.name
    },
    editChooseCate(tab, event) {
      if (tab.name === '+增加职能模块') {
        const hasCates = Object.keys(this.companyInEdit.categoryMoneyTable)
        const cates = app.categories.map((v) => v.名称).filter((v) => !hasCates.includes(v))
        this.$refs.SelectDialog.open({ label: '职能模块', option: cates })
      } else {
        this.activeCateTableInEdit = this.companyInEdit.categoryMoneyTable[tab.name]
        this.activeCateTableInEditCate = tab.name
      }
    },
    addCategory(category) {
      const newTable = { table: [], content: moneyContent }
      this.$set(this.companyInEdit.categoryMoneyTable, category, window._.cloneDeep(newTable))
      this.activeCateTableInEdit = this.companyInEdit.categoryMoneyTable[category]
      this.activeCateTableInEditCate = category
    },
  }
}
</script>
<style>
.money-table-box .el-tabs--card > .el-tabs__header {
  border-bottom-color: transparent;
}
.money-table-box .el-tabs--card > .el-tabs__header .el-tabs__item {
  padding: 0 15px;
  height: 30px;
  line-height: 30px;
  border-bottom-color: #e4e7ed;
}
.money-table-box .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #fff;
}
.money-table-box .el-tabs__header {
  margin-bottom: 10px;
}
.choose-log-tag .el-dialog__body {
  padding-top: 0;
}
</style>
<style src="../../../../../company/statistics/css/commonCompany.css" scoped></style>
<style src="../../../../../company/statistics/css/fullCompanyDetail.css" scoped></style>
<style scoped>
.money-table-box {
  padding: 10px 20px;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  background-color: #fff;
}
.bg-box {
  border-radius: 4px;
  background-color: #f2f2f2;
  padding: 10px;
}
.cate-tag {
  background-color: #eee;
  color: #afafaf;
  padding: 2px 10px;
  border-radius: 12px;
  margin-left: 6px;
  font-weight: normal;
}
.edit-dialog-part {
  border-bottom: none;
}
</style>
